<div class="row">
  <div class="col-6 col-md-4 col-lg-2">
    <div class="mb-3">
      <label class="form-label" for="years">
        Years
        <span *ngIf="controlIsRequired('Years')" class="color-error">*</span>
      </label>
      <input
        class="form-control"
        id="years"
        placeholder=""
        type="number"
        [formControl]="getFormControl('Years')"
        aria-label="Years at current address"
        min="0"
        step="1"
      />
    </div>
  </div>
  <div class="col-6 col-md-4 col-lg-2">
    <div class="mb-3">
      <label class="form-label" for="months">
        Months
        <span *ngIf="controlIsRequired('Months')" class="color-error">*</span>
      </label>
      <input
        class="form-control"
        id="months"
        placeholder=""
        type="number"
        [formControl]="getFormControl('Months')"
        aria-label="Months at current address"
        max="11"
        min="0"
        step="1"
      />
    </div>
  </div>
</div>
